import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6d9c7d0a&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=6d9c7d0a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c7d0a",
  null
  
)

export default component.exports